import React from "react";
import { required } from "react-admin";

import { GridForm, GridInput } from "../../../components/GridForm";
import { SelectEnumInput } from "components/inputs/SelectEnumInput";
import { ThirdPartyInput } from "components/inputs/ThirdPartyInput";
import { AppSecretType } from "entities/AppSecretType";


export const AppSecretForm = (props) => (
	<GridForm {...props}>
		<GridInput xs={12} sm={6} component={ThirdPartyInput} validate={required()} source="oauth2_client_id" autoFocus />
		<GridInput xs={12} sm={6} component={SelectEnumInput} validate={required()} source="type"
			enumObj={AppSecretType} enumName="app_secret_type" />
	</GridForm>
);
